// 回调地址校验
export const CHECK_RESULT = {
  NO_PASS: 0,
  PASS: 1
};
